/** @jsxImportSource @emotion/react */
import React from 'react'
import {
    Grid,
    GridItem,
    Button,
    Box, Text
} from '@chakra-ui/react'
import {Link} from 'react-router-dom'
import {ReactComponent as DownloadIcon} from '../../assets/downloadIconWhite.svg'
import moment from "moment/moment";
import {INVOICE} from "../../constants/orders/orderEnum";

const InvoicesTab = ({estimates, loading, downloadPdf}) => {
    return (
        <Box>
            {
                estimates?.filter((filtered) => filtered.isInvoice && !filtered?.archived)?.length > 0 ? (
                    <Grid fontSize='xl' fontFamily='Titillium Web' fontWeight='600' px={4} templateColumns="repeat(5, 1fr)">
                        <GridItem>Reference</GridItem>
                        <GridItem>Company</GridItem>
                        <GridItem>Date</GridItem>
                        <GridItem>Project</GridItem>
                        <GridItem pr={3} justifyContent='end' display='flex'>Download</GridItem>
                    </Grid>
                ) : (
                    <Text fontSize='18px' textAlign='center'>
                        No active invoices at this time - check back later!
                    </Text>
                )
            }
            {
                estimates?.filter((filtered) => filtered.isInvoice && !filtered?.archived).sort((a: any, b: any) => moment.utc(b?.invoiceDateCreated?.date).diff(moment.utc(a?.invoiceDateCreated?.date))).map((item: any) => (
                    <Grid px={4} mt={4} templateColumns="repeat(5, 1fr)" alignItems='center' minH='57px' bg='white' borderRadius='10px' border='2px solid #A9A9A9' key={item.orderUid} z-index='1'>
                        <GridItem textDecoration='underline'>
                            <Link to={`/orders/estimate/su/${item.id}/4`} z-index='999'>
                                {item.reference}
                            </Link>
                        </GridItem>
                        <GridItem>
                            <Link to={`/orders/estimate/su/${item.id}/4`} z-index='999'>
                                {item?.fulfilledByUserShippingSu?.company?.length > 0 ? item?.fulfilledByUserShippingSu?.company[0]?.name : item?.fulfilledByUserShippingSu?.associatedToCompany?.name}
                            </Link>
                        </GridItem>
                        <GridItem>
                            <Link to={`/orders/estimate/su/${item.id}/4`} z-index='999'>
                                {moment(item?.invoiceDateCreated?.date).format('MM/DD/YYYY')}
                            </Link>
                        </GridItem>
                        <GridItem>
                            <Link to={`/orders/estimate/su/${item.id}/4`} z-index='999'>
                                {item.report?.project?.city + ' (' + item.report?.project?.state + ')'}
                            </Link>
                        </GridItem>
                        <GridItem justifyContent='end' display='flex'>
                            <Button onClick={() => downloadPdf(item, INVOICE)} isLoading={loading[item.reference]} color='white' borderRadius='4px' width='90px' height='30px' bg='#2C628D'>
                                <DownloadIcon/>
                            </Button>
                        </GridItem>
                    </Grid>
                ))
            }
        </Box>
    )
}

export default InvoicesTab
